import { render } from "./GiftPage.vue?vue&type=template&id=b99c1f0e&scoped=true"
import script from "./GiftPage.vue?vue&type=script&lang=js"
export * from "./GiftPage.vue?vue&type=script&lang=js"

import "./GiftPage.vue?vue&type=style&index=0&id=b99c1f0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b99c1f0e"]])

export default __exports__